<template>
	<div>
		<!-- quotation package -->
		<div v-if="user.assignPackages.length > 0">
			<div>
				<modal
					v-if="dataAssignePackage.is_confirm === 0"
					class="swap-modal"
					size="small-medium"
					:hide-close-button="true"
					:layerIndex="9999">
					<template slot="header">
						<h5 class="mb-0">{{ $t('Information') }}</h5>
					</template>
					<template slot="body">
						<h2 class="mb-4 mt-4 text-left text-white">{{ $t('HELLO') }} {{dataAssignePackage && dataAssignePackage ? user.name : ''}}</h2>
						<h5 class="mb-2 text-left text-white">{{ $t('Quotation for package') }}:</h5>
						<h5 class="text-primary mb-0">{{dataAssignePackage.package.name}} ({{amountPaid(dataAssignePackage.package.price)}})</h5>
						<h5 class="mb-4">{{dataAssignePackage.package.description}}</h5>
						<h5 class="text-left text-white">{{ $t('Please click Proceed to confirm the purchase') }}.</h5>
					</template>
					<div slot="footer">
						<div class="d-flex">
							<div class="mr-6">
								<button
									@click="cancelQuotation(dataAssignePackage)"
									type="submit"
									class="btn btn-submit btn-default">
									{{ $t('Decline') }}
								</button>
							</div>
							<div class="ml-5 pl-4">
								<button
									@click="confirmQuotation(dataAssignePackage)"
									type="submit"
									class="btn btn-submit btn-primary">
									{{ $t('Proceed') }}
								</button>
							</div>
						</div>
					</div>
				</modal>
			</div>
		</div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import usersApi from '@/api/user';
import assignPackagesApi from '@/api/assign-packages';

export default {
	name: 'ModalQuotationConfirm',
	components: {
		Modal,
	},
	props: {
		rundowns: {
		},
		dataAssignePackage: {
		},
	},
	mounted() {
	},
	data: () => ({
		assigneePackage: [],
	}),
	methods: {
		close() {
			this.$emit('close');
			const callback = () => {
			};
			const errorCallback = () => {
			};
			usersApi.setLogin(callback, errorCallback);
		},
		confirmQuotation(data) {
			const callback = () => {
				this.$emit('close', data.package.id);
			};
			const errorCallback = () => {
			};
			const params = {
				is_confirm: 1,
			};
			assignPackagesApi.update(data.id, params, callback, errorCallback);
		},
		cancelQuotation(data) {
			const callback = () => {
				this.$emit('declined');
				this.$forceUpdate();
			};
			const errorCallback = () => {
			};
			const params = {
				is_confirm: 0,
			};
			assignPackagesApi.update(data.id, params, callback, errorCallback);
		},
		amountPaid(item) {
			const itemString = item.toString();
			const index = itemString.indexOf('-');
			if (index !== -1) {
				const removeMin = itemString.substring(1);
				return `-$${removeMin}`;
			}
			const addDelimiter = (item).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			return `$${addDelimiter}`;
		},
	},
	computed: {
		...mapGetters({
			isLoggedIn: 'isLoggedIn',
			user: 'user',
		}),
		rundownsData() {
			const rundowns = [];
			if (this.rundowns.length > 0) {
				for (let index = 0; index < this.rundowns.length; index++) {
					const element = this.rundowns[index];
					rundowns.push(element.name);
				}
				return rundowns.toString();
			}
			return rundowns.toString();
		},
		assigneePackageData() {
			const packages = this.user && this.user.assignPackages ? this.user.assignPackages : '';
			if (packages.length > 0) {
				for (let index = 0; index < packages.length; index++) {
					const element = packages[index];
					// eslint-disable-next-line
					this.assigneePackage.push(element);
				}
				return this.assigneePackage;
			}
			return this.assigneePackage;
		},
	},
};
</script>

<style lang="scss" scoped>
</style>
